import Swiper from 'swiper';

$(window).on('load', function () {
  const jsCaseSlider = new Swiper('.js-case-slider', {
    lazy: true,
    loop: true,
    slidesPerView: 'auto',
    width: 400,
    speed: 500,
    breakpoints: {
      767: {
        width: 200,
        // freeMode: true,
      }
    },
  });
  $('.js-case-next').on('click', function() {
    jsCaseSlider.slideNext();
  });
  $('.js-case-prev').on('click', function() {
    jsCaseSlider.slidePrev();
  });

  const jsHistorySlider = new Swiper('.js-history-slider', {
    lazy: true,
    loop: true,
    slidesPerView: 'auto',
    width: 340,
    speed: 500,
    breakpoints: {
      767: {
        width: 162,
        // freeMode: true,
      }
    },
  });
  $('.js-history-next').on('click', function() {
    jsHistorySlider.slideNext();
  });
  $('.js-history-prev').on('click', function() {
    jsHistorySlider.slidePrev();
  });
});
